import React, { Component } from "react";

import Authentication from "../APIs/Authentication";
import UploadFile from "../APIs/UploadFile";
import * as moment from "moment";
import axios from "axios";
import AcceptShipment from "../APIs/AcceptShipment";
import DeclineShipment from "../APIs/DeclineShipment";
import MessagesRead from "../APIs/MessagesRead";
import SendMessage from "../APIs/SendMessage";
import SubmitUpdate from "../Components/ShipmentCard/Components/SubmitUpdate";
import MailIcon from "../SmallComponents/MailIcon";
import AcceptDeclineStatus from "./AcceptDeclineStatus/AcceptDeclineStatus";
import UserContext from "../UserDataContext";
import DateChecker, { isShipmentTooOldToUpdate } from "../CustLogicAndFilters/DateChecker";
import SendEmail from "../Helpers/SendEmail";
import SendDeclineShipmentEmail from "../Helpers/SendDeclineShipmentEmail"
import CheckDockSchedulerQualification from "../APIs/CheckDockSchedulerQualifcation.js";
import { getShipmentV4 } from "../APIs/Helpers";
import KwikTripLiveDropNotice from "./KwikTripLiveDropNotice/KwikTripLiveDropNotice.js";
import InovataUSDARequired from "./InovataUSDARequired/InovataUSDARequired.js";

import * as SCC from "../Components/ShipmentCard/Components/index";
import ShipmentDebugView from "../DevTools/ShipmentDebugView";
import WhatsMissingListAurora from "./WhatsMissingListAurora";
import AuroraBilledCostModal from "./AuroraBilledCostModal";
import AcceptedUploadTypes from "../Helpers/AcceptedUploadTypes";

class ShipmentCard extends Component {

  static contextType = UserContext;
  constructor() {
    super();
    this._auroraModalPending = false;
    this._deferRefresh = false;
    this.documentUploadHandleChangeDocSelect = this.documentUploadHandleChangeDocSelect.bind(
      this
    );
    // this.handleSubmitUpload = this.handleSubmitUpload.bind(this);
    // this.handleSubmitUpdateShipment = this.handleSubmitUpdateShipment.bind(
    //   this
    // );
    this.handleChangeGeneric = this.handleChangeGeneric.bind(this);
    // this.handleChangeFileChange = this.handleChangeFileChange.bind(this);
    this.fileInput = React.createRef();
    this.shipmentID = React.createRef();
    this.shipmentIDUpdate = React.createRef();
    this.onHideDocs = this.onHideDocs.bind(this);
    this.modalOpenDocs = this.modalOpenDocs.bind(this);
    this.modalOpenMessaging = this.modalOpenMessaging.bind(this);
    this.onHideMessages = this.onHideMessages.bind(this);
    this.setShipmentStatus = this.setShipmentStatus.bind(this);
    this.markMessageReadOnOpen = this.markMessageReadOnOpen.bind(this);
    this.handleAcceptShipment = this.handleAcceptShipment.bind(this);
    this.handleDeclineShipment = this.handleDeclineShipment.bind(this);
    this.handleAcceptShipmentChanges = this.handleAcceptShipmentChanges.bind(
      this
    );
    this.handleDeclineShipmentChanges = this.handleDeclineShipmentChanges.bind(
      this
    );
    this.populateChargeNotes = this.populateChargeNotes.bind(this);
    this.startUpAndUpdateLogic = this.startUpAndUpdateLogic.bind(this);
    this.checkBilledVsEstCost = this.checkBilledVsEstCost.bind(this);
    this.genericModalShow = this.genericModalShow.bind(this);
    this.genericModalHide = this.genericModalHide.bind(this);
    this.hideSchuffGPSModal = this.hideSchuffGPSModal.bind(this);
    this.tableEditModeOnOffCard = this.tableEditModeOnOffCard.bind(this);
    this.tableEditCheckEvent = this.tableEditCheckEvent.bind(this);
    this.hashForTableEditCheckboxID = this.hashForTableEditCheckboxID.bind(
      this
    );
    this.condRenderCardBodyDetail = this.condRenderCardBodyDetail.bind(this);
    this.showDetailsForms = this.showDetailsForms.bind(this);
    this.showUpdateAlert = this.showUpdateAlert.bind(this);
    this.localUpDateSingleShipment = this.localUpDateSingleShipment.bind(this);
    this.checkForUnreadMessages = this.checkForUnreadMessages.bind(this);
    this.markMessagesReadLocally = this.markMessagesReadLocally.bind(this);
    this.copyInvoice2ToInvoicePro = this.copyInvoice2ToInvoicePro.bind(this);
    this.checkProPlusInvoice = this.checkProPlusInvoice.bind(this);
    this.checkDateSetState = this.checkDateSetState.bind(this);
    this.shipmentObjUpdateEvent = this.shipmentObjUpdateEvent.bind(this);
    this.shipmentObjUpdateDirect = this.shipmentObjUpdateDirect.bind(this);
    this.showHilightOrHide = this.showHilightOrHide.bind(this);
    this.setAndShowGenericModal = this.setAndShowGenericModal.bind(this);

    this.buildFormDataForShipmentUpdate = this.buildFormDataForShipmentUpdate.bind(
      this
    );
    this.documentUploadFileChangeHandler = this.documentUploadFileChangeHandler.bind(
      this
    );
    this.documentUploadBuildFormData = this.documentUploadBuildFormData.bind(
      this
    );
    this.handleSettledDocumentUpload = this.handleSettledDocumentUpload.bind(
      this
    );
    this.addAccessorialRequest = this.addAccessorialRequest.bind(this);
    this.clearAddedAccessorials = this.clearAddedAccessorials.bind(this);
    this.updateWasSubmittedIncrement = this.updateWasSubmittedIncrement.bind(this);
    this.populateShipmentV4 = this.populateShipmentV4.bind(this);
    this.foremostCheckForApprovedCost = this.foremostCheckForApprovedCost.bind(this);
    this._wrappedRefreshShippments = this._wrappedRefreshShippments.bind(this);

    this.state = {
      disabledForm: false,
      expandCardDetailsForm: false,
      chargesMessage: "",
      docsModalShow: false,
      messagesModalShow: false,
      showGenericModal: false,
      showSchuffGPSModal: false,
      schuffGPSModalTitle: "",
      schuffGPSModalBody: "",
      schuffGPSModalDisplayPhone: false,
      schuffGPSModalDisplayTruck: false,
      schuffGPSModalPhonePlaceholderText: "",
      shipmentUpdateAlert: "hide",
      docUploadedAlert: "hide",
      showHideCheckBoxForTableEditMode: "checkShipmentBoxHide",
      arrowWidth: 2,
      tableSelect: false,
      updateAlertStatus: "hide",
      messagesIcon: "hide",
      estimatedDeliveryDate: "hide",
      numMessages: 0,
      numUnreadMessages: 0,
      updatedFormData: "",
      documentUploadFile: null,
      documentUploadFileName: null,
      documentUploadFileType: null,
      settledDocUploadInProgress: false,
      settledDocUploadStatus: null,
      settledDocUploadStatusType: "alert alert-secondary border-secondary",
      acceptDeclineStatusState: 'none',
      // New accessorial Reuests
      newAccesorialRequests: [],
      billedChargesPending: false,
      dockSchedulerQualification: false,
      updateWasSubmitted: 1,
      showAuroraBillingModal: false,
      shipmentV4: null,
      tenderAcceptDeclineButtonsDisabled: false,
      inputFieldsReadOnly: false,
      language: this?.props?.language || { code: "en", label: "Default" }
    };
  }

  componentDidMount() {
    this.startUpAndUpdateLogic("propsUpdate");
    this.hashForTableEditCheckboxID();
  }

  componentWillUnmount() {
    // Need to clear the interval or it will continue to run even when the component is unmounted
    this.setState({ updateAlertStatus: "hide" });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.shipment !== prevProps.shipment) {
      // console.log("debug shipmentcard2 compdidupdate props check");
      this.startUpAndUpdateLogic("propsUpdate");
    }
    if (this.props.tableEditMode !== prevProps.tableEditMode) {
      this.tableEditModeOnOffCard();
    }
    // If language prop changes, update state
    if (this.props?.language?.code !== prevProps?.language?.code) {
      this.setState({ language: this.props.language });
    }
  }

  incrementUpdateWasSubmitted() {
    this.setState({ updateWasSubmitted: this.state.updateWasSubmitted + 1 })
  }

  clearAddedAccessorials() {
    this.setState({ newAccesorialRequests: [] })
  }
  addAccessorialRequest(accessorial) {
    // console.log('adding accesorial', accessorial)
    let newAccesorialsRequestsArray = this.state.newAccesorialRequests
    let newAccessorial = accessorial
    newAccesorialsRequestsArray.push(newAccessorial)
    this.setState({ newAccesorialRequests: newAccesorialsRequestsArray })
  }

  copyInvoice2ToInvoicePro() {
    this.shipmentObjUpdateDirect(
      "charges.trackingNumber",
      this.state.shipment.charges.invoiceNumber
    );
  }

  // billedChargesPending() {
  //   this.setState({ billedChargesPending: true })
  // }

  checkForUnreadMessages() {
    let unreadMessages = this.props.shipment.log.filter(
      (log) =>
        log.type === "Message" && log.read === 0 && log.usercode !== "Carrier"
    );

    let messagesButAllRead = this.props.shipment.log.filter(
      (log) =>
        log.type === "Message" && log.read === 1 && log.usercode !== "Carrier"
    );

    if (this.props.shipment.log.length && messagesButAllRead.length) {
      this.setState({
        messagesIcon: "messagesNoUnread",
        numMessages: messagesButAllRead.length,
      });
    }
    if (this.props.shipment.log.length && unreadMessages.length) {
      this.setState({
        messagesIcon: "unreadMessages",
        numUnreadMessages: unreadMessages.length,
      });
    }
    if (
      this.props.shipment.log.length &&
      !unreadMessages.length &&
      !messagesButAllRead.length
    ) {
      this.setState({
        messagesIcon: "noMessages",
      });
    }

    if (!this.props.shipment.log.length) {
      this.setState({
        messagesIcon: "noMessages",
      });
    }
  }

  markMessagesReadLocally() {
    this.setState({
      numUnreadMessages: 0
    });
  }

  foremostCheckForApprovedCost(shipment) {
    // sample 158767028
    if (shipment && shipment?.charges?.approvedCost) {
      this.setState({ inputFieldsReadOnly: true })
    }
  }

  startUpAndUpdateLogic(updateType) {
    // console.log("debug startUPAndUPdateLogic fired");
    if (updateType === "propsUpdate") {
      // Setting shipmentCloneWithoutReference so that this.state.shipment doesn't have a reference to this.props.shipment and so that when you modify one, you're not modifying both since we use this.props.shipment to check if a given value has been changed or not
      const { shipment } = { ...this.props };
      let shipmentCloneWithoutReference = JSON.parse(JSON.stringify(shipment));
      this.setState({ shipment: shipmentCloneWithoutReference });
      this.populateChargeNotes();
      this.tableEditModeOnOffCard();
      this.checkForUnreadMessages();
      if (this.context.clientCode === "foremost") {
        this.foremostCheckForApprovedCost(shipment)
      }
      CheckDockSchedulerQualification(shipment).then((result) => {
        this.setState({ dockSchedulerQualification: result })
      });

      if ((shipment.customerId === "Schuff" || shipment.customerId === "Graywolf" || shipment.customerId === "graywolf") && shipment.status.statusId === "OK") {
        this.setState({ disabledForm: "disabled" })
      }
      // set language in state
      if (this.props.language && this.props.language.code) {
        this.setState({ language: this.props.language })
      }
    }
  }

  checkDateSetState(date) {
    // console.log("checkDateSetState fired", date);
    if (date === "0001-01-01T00:00:00") {
      return "";
    } else {
      return date;
    }
  }

  showHilightOrHide(field) {
    if (this.props.showFields?.includes(field)) return "show";
    else if (this.props.hilightFields?.includes(field)) return "hilight";
    else return "hide";
    // allUpdateFieldsHilightHide
  }

  // Aurora is otherwise exempt from the "shipment settled" full-form lock (see the
  // settlementId check around the update form), but Billed Charges, Invoice Number,
  // Invoice / Pro Number, and Status (other than Delivered) must still lock once settled.
  auroraSettlementFieldsLocked() {
    return this.context.clientCode === "aurora" && !!this.props.shipment.settlementId;
  }

  // For Docs modal
  onHideDocs() {
    this.setState({ docsModalShow: false });
  }

  modalOpenDocs(event) {
    event.preventDefault();
    this.setState({ docsModalShow: true });
  }

  // For MessagesModal
  modalOpenMessaging(event) {
    event.preventDefault();
    this.setState((prevState) => ({
      messagesModalShow: !prevState.messagesModalShow,
    }));
    this.setState({ messagesModalShow: true });
    this.markMessageReadOnOpen();
  }

  onHideMessages() {
    this.setState({ messagesModalShow: false });
  }

  // Accept Shipment
  async handleAcceptShipment() {
    let shipmentId = this.props.shipment.id
    let macroPointMessage = 'Please make sure to use our MPID 1071335 to send us GPS tracking data. Enter our BOL #: ' + shipmentId + ' as the load identifier.'
    //  this.setAndShowGenericModal('Title', 'Body');
    if (this.context && this.context.clientCode === "Schuff" && this.context.hasOwnProperty("gpsTracking") && !!this.props.shipment.gpsTracking && this.props.shipment.gpsTracking.length > 0) {
      if (this.context.gpsTracking === null) {

        this.setAndShowSchuffGPSModal('GPS Phone Tracking Notice', "If you have the driver's cell phone number please fill out the field below.  If you do not have the phone number you can update this later on the Carrier Portal.  The Driver will then receive a text message soon to track the load with Macropoint GPS Tracking.", true, "Driver's Cell Phone Number (no dashes)", false);
      }
      if (this.context.gpsTracking === 'MacroPoint') {
        if (this.context.gpsMethod === 'Telematics') {
          macroPointMessage = "Our system will put in a tracking request to connect directly with ELD/Telematics system once the Truck Number is entered."
          this.setAndShowSchuffGPSModal('GPS Macropoint Tracking Notice', macroPointMessage, true, "Enter Phone Number here if Cell Phone Tracking Needed instead of Direct ELD/TMS Connection", true);
        } else {
          this.setAndShowSchuffGPSModal('GPS Macropoint Tracking Notice', macroPointMessage, true, "Enter Phone Number if Cell Phone Tracking Needed instead of Direct ELD/TMS Connection", false);
        }

      }
    }
    let userEmail = ""
    if (this.context) {
      userEmail = this.context.email
    }
    let userName = ""
    if (this.context) {
      userName = this.context.name
    }
    this.setState({ acceptDeclineStatusState: "loading" });
    let result = await AcceptShipment.AcceptShipment(this.props.shipment.id, this.props.shipment.loadDetails.secureId, userEmail, userName);
    if (result.response === "success") {
      this.setState({ acceptDeclineStatusState: "success" });
      this.setState({ tenderAcceptDeclineButtonsDisabled: true })
    } else {
      this.setState({ acceptDeclineStatusState: "error" });
      this.setState({ tenderAcceptDeclineButtonsDisabled: false })
    }
    if (this.showHilightOrHide('sendPUEmailOnAccept') === "show") {
      SendEmail(this.props.shipment, this.context)
    }

  }

  //Decline Shipment
  async handleDeclineShipment() {
    let userEmail = ""
    if (this.context) {
      userEmail = encodeURIComponent(this.context.email)
    }
    let userName = ""
    if (this.context) {
      userName = encodeURIComponent(this.context.name)
    }
    this.setState({ acceptDeclineStatusState: "loading" });
    let result = await DeclineShipment.DeclineShipment(this.props.shipment.id, this.props.shipment.loadDetails.secureId, userEmail, userName)
    if (result.response === "success") {
      this.setState({ acceptDeclineStatusState: "success" });
      this.setState({ tenderAcceptDeclineButtonsDisabled: true })
    } else {
      this.setState({ acceptDeclineStatusState: "error" });
      this.setState({ tenderAcceptDeclineButtonsDisabled: false })
    }
    if (this.showHilightOrHide('sendEmailOnDecline') === "show") {
      SendDeclineShipmentEmail(this.props.shipment, this.context)
    }

  }

  // Accept Load Changes
  handleAcceptShipmentChanges() {
    MessagesRead.MarkAllMessagesRead(this.props.shipment.id);
    this.setState({ acceptDeclineStatusState: "success" });
  }

  // Decline Load Changes
  handleDeclineShipmentChanges() {
    DeclineShipment.DeclineShipment(this.props.shipment.id, this.props.shipment.loadDetails.secureId);
    MessagesRead.MarkAllMessagesRead(this.props.shipment.id);
    this.setState({ acceptDeclineStatusState: "success" });
  }

  //Mark as read (move this to the api folder later)
  markMessageReadOnOpen() {
    axios
      .get(
        "https://www2.shippersedge.com/public/carrier/markAllMessagesRead.cfm?wsdl&i=" +
        this.props.shipment.id
      )
      .then((response) => {

      })
      .catch((error) => {
        if (error) {
          console.warn(
            "ShipmentCard2.js, error on markMessageReadOnOpen:",
            error
          );
        }
      });
  }

  //
  // New documentUpload upload functions
  //
  documentUploadFileChangeHandler(event) {
    // console.log("newFileChange", event.target.files[0]);
    // console.log("newFileChange name", event.target.files[0].name);
    this.setState({
      documentUploadFileName: event.target.files[0].name,
      documentUploadFile: event.target.files[0],
    });
  }
  documentUploadHandleChangeDocSelect(event) {
    // console.log(event.target.value);
    this.setState({ documentUploadFileType: event.target.value });
  }

  documentUploadBuildFormData() {
    return new Promise((resolve) => {
      const uploadData = new FormData();
      uploadData.append("shipmentId", this.state.shipment.id.toString());
      uploadData.append("fileType", this.state.documentUploadFileType);
      uploadData.append(
        "file",
        this.state.documentUploadFile,
        this.state.documentUploadFileType
      );
      uploadData.append("contactEmail", Authentication.getEmailAddress());
      resolve(uploadData);
    });
  }

  // Standalone document upload for settled shipments, where the full
  // "Update Shipment" form (and its SubmitUpdate submit handler) is hidden.
  // Mirrors the document upload call SubmitUpdate.js makes internally, but
  // without any of that component's other field updates/validation.
  async handleSettledDocumentUpload() {
    if (!this.state.documentUploadFile) {
      this.setState({
        settledDocUploadStatus: "Please choose a file to upload.",
        settledDocUploadStatusType: "alert alert-warning border-warning",
      });
      return;
    }
    if (!this.state.documentUploadFileType) {
      this.setState({
        settledDocUploadStatus: "Please select a document type from the dropdown menu.",
        settledDocUploadStatusType: "alert alert-warning border-warning",
      });
      return;
    }

    this.setState({
      settledDocUploadInProgress: true,
      settledDocUploadStatus: "Uploading document...",
      settledDocUploadStatusType: "alert alert-secondary border-secondary",
    });

    const formData = await this.documentUploadBuildFormData();
    let result = await UploadFile.UploadNew(formData, 10000);
    if (result === "Aborted") {
      this.setState({
        settledDocUploadStatus: "Document upload timed out, trying again ...",
        settledDocUploadStatusType: "alert alert-secondary border-secondary",
      });
      result = await UploadFile.UploadNew(formData, 20000);
    }
    if (result === "Aborted") {
      this.setState({
        settledDocUploadStatus: "Document upload timed out, trying again (second retry) ...",
        settledDocUploadStatusType: "alert alert-secondary border-secondary",
      });
      result = await UploadFile.UploadNew(formData, 35000);
    }

    if (result === "Aborted") {
      this.setState({
        settledDocUploadInProgress: false,
        settledDocUploadStatus: "Document failed to upload due to network timeout, please refresh your browser and try again.",
        settledDocUploadStatusType: "alert alert-danger border-danger",
      });
      return;
    }

    this.setState({
      settledDocUploadInProgress: false,
      settledDocUploadStatus: "Document uploaded!",
      settledDocUploadStatusType: "alert alert-success border-success",
      documentUploadFile: null,
      documentUploadFileName: null,
    });
    this._wrappedRefreshShippments();
  }

  setAndShowGenericModal(genericModalTitle, genericModalBody) {
    this.setState({
      genericModalTitle: genericModalTitle,
      genericModalBody: genericModalBody,
      showGenericModal: true,
    });
  }


  setAndShowSchuffGPSModal(title, body, phone, phonePlaceholderText, truck) {
    this.setState({
      schuffGPSModalTitle: title,
      schuffGPSModalBody: body,
      schuffGPSModalDisplayPhone: phone,
      showSchuffGPSModal: true,
      schuffGPSModalPhonePlaceholderText: phonePlaceholderText,
      schuffGPSModalDisplayTruck: truck
    });
  }




  hideSchuffGPSModal() {
    this.setState({
      showSchuffGPSModal: false,
      schuffGPSModalTitle: "default text",
      schuffGPSModalBody: "default text",
      schuffGPSModalDisplayPhone: false,
      schuffGPSModalPhonePlaceholderText: "default text",
      schuffGPSModalDisplayTruck: false
    });
  }

  handleSubmitUpload(event) {
    event.preventDefault();

    const uploadData = new FormData();
    uploadData.append("shipmentId", this.shipmentID.value.toString());
    uploadData.append("fileType", this.state.fileType);
    uploadData.append(
      "file",
      this.fileInput.current.files[0],
      this.state.fileType
    );
    uploadData.append("contactEmail", Authentication.getEmailAddress());
    UploadFile.Upload(uploadData); // need to add some callback here for the promise, maybelook for "tripped up and etc"
    setTimeout(this.localUpDateSingleShipment, 3000);
    this.setState({ docUploadedAlert: "show" });
  }

  // This is a generic change handler that will set state based on the "name" value of the html element and set the value in state, this should work for most fields
  handleChangeGeneric(event) {
    event.preventDefault();
    // console.log(
    //   "handleChangeGeneric",
    //   event.target.name,
    //   "-",
    //   event.target.value
    // );
    this.setState({ [event.target.name]: event.target.value });
  }

  shipmentObjUpdateEvent(event, newValue = null) {

    event.preventDefault();
    const { name, value: eventValue } = event.target;
    let value = newValue || eventValue;

    if (name === "charges.billedCost" && typeof value === "string") {
      value = value.replace(/,/g, "");
    }
    const { shipment } = { ...this.state };
    const splitOutput = name.split(".");
    const newState = shipment;
    function setDeep(obj, path, value, setrecursively = false) {
      let level = 0;
      path.reduce((a, b) => {
        level++;
        if (
          setrecursively &&
          typeof a[b] === "undefined" &&
          level !== path.length
        ) {
          a[b] = {};
          return a[b];
        }
        if (level === path.length) {
          a[b] = value;
          return value;
        } else {
          return a[b];
        }
      }, obj);
    }
    setDeep(newState, splitOutput, value);

    this.setState({ shipment: newState });
  }

  shipmentObjUpdateDirect(path, value) {
    const { shipment } = { ...this.state };
    const splitOutput = path.split(".");
    const newState = shipment;
    function setDeep(obj, path, value, setrecursively = false) {
      let level = 0;
      path.reduce((a, b) => {
        level++;
        if (
          setrecursively &&
          typeof a[b] === "undefined" &&
          level !== path.length
        ) {
          a[b] = {};
          return a[b];
        }
        if (level === path.length) {
          a[b] = value;
          return value;
        } else {
          return a[b];
        }
      }, obj);
    }
    setDeep(newState, splitOutput, value);

    this.setState({ shipment: newState });
  }

  // Search the messages log for any charges messages (anything that includes "ChargesNote: ")
  populateChargeNotes() {
    const chargesMessages = this.props.shipment.log.filter(
      (item) =>
        item?.type === "Message" && item?.entryDetails?.includes("ChargesNote: ")
    );
    // Need to account for null so we don't populate all charges notes with null if the DB returns that.
    if (
      chargesMessages.length &&
      chargesMessages[0].entryDetails !== "ChargesNote: null"
    ) {
      const chargesMessageSorted = chargesMessages.sort((a, b) => b.id - a.id);
      this.setState({
        chargesMessage: chargesMessageSorted[0].entryDetails.slice(13),
      });
    } else {
      this.setState({
        chargesMessage: "",
      });
    }
  }

  // A check to see if billedCost and esttimatedCost are the same, if not pop up a modal asking them to fill out the Charges Notes: if they haven't already
  checkBilledVsEstCost() {
    // console.log("checkBilledVsEstCost fired", parseFloat(this.state.billedCost), parseFloat(this.props.shipment.charges.estimatedCost));
    if (
      parseFloat(this.state.shipment.charges.billedCost) ===
      parseFloat(this.props.shipment.charges.estimatedCost)
    ) {
      return true;
    } else if (
      this.state.chargesMessage === null &&
      this.state.shipment.charges.billedCost !== ""
    ) {
      // console.log("checkBilledVsEstCost chargesMessage Null");
      this.setState({
        genericModalTitle: "Billed Cost Is Different Than Estimated Cost",
        genericModalBody:
          "If the Billed Cost is different than the Estimated Cost please add a note as to why in the 'Charges Notes' field next to Billed Charges.  Thank you.",
      });
      this.genericModalShow();
      return false;
    } else {
      return true;
    }
  }

  // The check at the start of this is to make sure we don't resubmit the same message value each time someone submits a form, if the value is the same, doesn't submit
  // This uses the messages system to handle charges messages (in the past it used a field in carrier settlement, now using messages)
  checkAndSubmitChargesNotes() {
    // console.log("the existing value", this.state.chargesMessage)
    let checkPropsMessages = [];
    checkPropsMessages = this.props.shipment.log.filter(
      (item) =>
        item.type === "Message" && item.entryDetails.includes("ChargesNote: ")
    );
    // console.log("checkAndSubmitChargesNotes()", checkPropsMessages[0].entryDetails.slice(13))
    if (checkPropsMessages.length) {
      // Had a few occurances where null turned into "null" text and repeated messages, will change this when Shipmentcard2 gets an overhaul.   Until then the below filter duplicate or unwanted values.
      if (
        this.state.chargesMessage ===
        checkPropsMessages[0].entryDetails.slice(13) ||
        this.state.chargesMessage === "Reason for charges here" ||
        this.state.chargesMessage === null ||
        this.state.chargesMessage === "null" ||
        this.state.chargesMessage === "ChargesNote: null"
      ) {
        // console.log("checkAndSubmitChargesNotes() caught unwanted chargesNotes value:", this.state.chargesMessage)
        return null;
      } else {
        //If the billed charges note is a new Message
        const prependedMsg = "ChargesNote: " + this.state.chargesMessage;
        const messageData = new FormData();
        messageData.append("shipmentId", this.props.shipment.id.toString());
        messageData.append("usercode", "Carrier");
        messageData.append("contactEmail", Authentication.getEmailAddress());
        messageData.append("message", prependedMsg);
        SendMessage.Send(messageData);
      }
    } else {
      // Had a few occurances where null turned into "null" text and repeated messages, will change this when Shipmentcard2 gets an overhaul.   Until then the below filter duplicate or unwanted values.
      if (
        this.state.chargesMessage === "Reason for charges here" ||
        this.state.chargesMessage === null ||
        this.state.chargesMessage === "null" ||
        this.state.chargesMessage === "ChargesNote: null"
      ) {
        // console.log("checkAndSubmitChargesNotes() caught unwanted chargesNotes value:", this.state.chargesMessage)
        return null;
      } else {
        // console.log("null hits here 2");
        //If no billed charges notes exist
        // console.log("checkAndSubmitChargesNotes last else");
        const prependedMsg = "ChargesNote: " + this.state.chargesMessage;
        const messageData = new FormData();
        messageData.append("shipmentId", this.props.shipment.id.toString());
        messageData.append("usercode", "Carrier");
        messageData.append("contactEmail", Authentication.getEmailAddress());
        messageData.append("message", prependedMsg);
        SendMessage.Send(messageData);
      }
    }
  }

  // Gould wants to be sure that if there is a billed cost entered then there must be a pro/tracking number
  // Eventualy need to figureo ut a way to abstract this sort of customer specific checking another way
  checkProPlusInvoice() {
    if (
      localStorage.getItem("carrierClientId") === "gould" &&
      this.state.shipment.charges.billedCost !==
      this.props.shipment.charges.billedCost &&
      (this.state.shipment.charges.trackingNumber === null ||
        this.state.shipment.charges.trackingNumber === "")
    ) {
      return false;
    } else {
      return true;
    }
  }

  buildFormDataForShipmentUpdate() {
    return new Promise((resolve) => {
      // console.log("buildFormDataForShipmentUpdate");
      const updateData = new FormData();
      // shipmentID, contactEmail, status are required for an update to work
      updateData.append("shipmentID", this.props.shipment.id);
      updateData.append("contactEmail", Authentication.getEmailAddress());
      updateData.append("status", this.state.shipment.status.statusId);
      //
      if (
        this.state.shipment.charges.invoiceNumber !==
        this.props.shipment.charges.invoiceNumber
      ) {
        updateData.append(
          "invoiceNum",
          this.state.shipment.charges.invoiceNumber
        );
      }

      // Carrier Nmae
      if (
        this.state.shipment.carrierName !==
        this.props.shipment.carrierName
      ) {
        updateData.append(
          "carrierName",
          this.state.shipment.carrierName
        );
      }
      // Driver phone
      if (
        this.state.shipment.loadDetails.driverPhone !==
        this.props.shipment.loadDetails.driverPhone
      ) {
        updateData.append(
          "driver_phone",
          this.state.shipment.loadDetails.driverPhone
        );
      }

      // Truck Number
      if (
        this.state.shipment.loadDetails.truckNumber !==
        this.props.shipment.loadDetails.truckNumber
      ) {
        updateData.append(
          "truck_number",
          this.state.shipment.loadDetails.truckNumber
        );
      }

      // Trailer Number
      if (
        this.state.shipment.loadDetails.trailerNumber !==
        this.props.shipment.loadDetails.trailerNumber
      ) {
        updateData.append(
          "trailer_number",
          this.state.shipment.loadDetails.trailerNumber
        );
      }

      if (
        this.state.invoiceDate !== undefined &&
        this.state.invoiceDate !== this.props.shipment.charges.invoiceDate &&
        ((this.state.invoiceDate && DateChecker(this.state.invoiceDate)) ||
          this.state.invoiceDate === "")
      ) {
        updateData.append("invdate", this.state.invoiceDate);
      }
      if (
        this.state.shipment.charges.trackingNumber !==
        this.props.shipment.charges.trackingNumber
      ) {
        // console.log(
        //   "debug state.trackingNumber",
        //   this.state.shipment.charges.trackingNumber,
        //   "debug props trackingNumber",
        //   this.props.shipment.charges.trackingNumber
        // );
        updateData.append("pronum", this.state.shipment.charges.trackingNumber);
      }

      // Appointment Pickup:
      // Appointment Pickup Date
      if (
        this.state.shipment.dates.appointmentPickupDate !==
        this.props.shipment.dates.appointmentPickupDate
      )
        updateData.append(
          "apptPUDate",
          this.state.shipment.dates.appointmentPickupDate
        );
      // Appointment Pickup Time In
      if (
        this.state.shipment.dates.appointmentPickupTimeIn !==
        this.props.shipment.dates.appointmentPickupTimeIn
      )
        updateData.append(
          "apptPUInTime",
          moment(
            this.state.shipment.dates.appointmentPickupTimeIn,
            "HH:mm"
          ).format("HH:mm:ss")
        );
      // Appointment Pickup Time Out
      if (
        this.state.shipment.dates.appointmentPickupTimeOut !==
        this.props.shipment.dates.appointmentPickupTimeOut
      )
        updateData.append(
          "apptPUOutTime",
          moment(
            this.state.shipment.dates.appointmentPickupTimeOut,
            "HH:mm"
          ).format("HH:mm:ss")
        );

      // Actual Pickup:
      // Actual Pickup Date
      if (
        this.state.shipment.dates.pickupDate !==
        this.props.shipment.dates.pickupDate
      )
        updateData.append("pudate", this.state.shipment.dates.pickupDate);
      // Actual Pickup Time In
      if (
        this.state.shipment.dates.pickupTimeIn !==
        this.props.shipment.dates.pickupTimeIn
      )
        updateData.append(
          "puInTime",
          moment(this.state.shipment.dates.pickupTimeIn, "HH:mm:").format(
            "HH:mm:ss"
          )
        );
      // Actual Pickup Time Out
      if (
        this.state.shipment.dates.pickupTimeOut !==
        this.props.shipment.dates.pickupTimeOut
      )
        updateData.append(
          "puOutTime",
          moment(this.state.shipment.dates.pickupTimeOut, "HH:mm:").format(
            "HH:mm:ss"
          )
        );

      // Estimated Delivery Date:
      // masterquotes.estdeldate
      if (
        this.state.shipment.dates.estimatedDeliveryDate !==
        this.props.shipment.dates.estimatedDeliveryDate
      ) {
        updateData.append(
          "estimatedDeliveryDate",
          this.state.shipment.dates.estimatedDeliveryDate
        );
      }

      if (
        this.state.shipment.dates.estimatedDelivery !==
        this.props.shipment.dates.estimatedDelivery
      ) {
        updateData.append(
          "estimatedDeliveryDate",
          this.state.shipment.dates.estimatedDelivery
        );
      }

      // Estimated Pickup
      // masterquotes.estpudate
      // V2 Shipment object shipment.dates.estimatedPickup
      if (
        this.state.shipment.dates.estimatedPickup !==
        this.props.shipment.dates.estimatedPickup
      ) {
        updateData.append(
          "estpudate",
          this.state.shipment.dates.estimatedPickup
        );
      }

      // masterquotes.estputime
      // V2 Shipment object shipment.dates.estimatedPickupTime
      if (
        this.state.shipment.dates.estimatedPickupTime !==
        this.props.shipment.dates.estimatedPickupTime
      ) {
        updateData.append(
          "estputime",
          this.state.shipment.dates.estimatedPickupTime
        );
      }

      // masterquotes.estputime
      // V2 Shipment object shipment.dates.estimatedDeliveryTime
      if (
        this.state.shipment.dates.estimatedDeliveryTime !==
        this.props.shipment.dates.estimatedDeliveryTime
      ) {
        updateData.append(
          "estdeltime",
          this.state.shipment.dates.estimatedDeliveryTime
        );
      }



      // Appointment Delivery:
      // Appointment Delivery Date
      if (
        this.state.shipment.dates.appointmentDeliveryDate !==
        this.props.shipment.dates.appointmentDeliveryDate
      )
        updateData.append(
          "apptDelDate",
          this.state.shipment.dates.appointmentDeliveryDate
        );
      // Appointment Delivery Time In
      if (
        this.state.shipment.dates.appointmentDeliveryTimeIn !==
        this.props.shipment.dates.appointmentDeliveryTimeIn
      )
        updateData.append(
          "apptDelInTime",
          moment(
            this.state.shipment.dates.appointmentDeliveryTimeIn,
            "HH:mm:"
          ).format("HH:mm:ss")
        );

      // Appointment Delivery Time Out
      if (
        this.state.shipment.dates.appointmentDeliveryTimeOut !==
        this.props.shipment.dates.appointmentDeliveryTimeOut
      )
        updateData.append(
          "apptDelOutTime",
          moment(
            this.state.shipment.dates.appointmentDeliveryTimeOut,
            "HH:mm:"
          ).format("HH:mm:ss")
        );

      // Actual Delivery:
      // Actual Delivery Date
      if (
        this.state.shipment.dates.deliveryDate !==
        this.props.shipment.dates.deliveryDate
      )
        updateData.append("deldate", this.state.shipment.dates.deliveryDate);
      // Actual Delivery Time In
      if (
        this.state.shipment.dates.deliveryTimeIn !==
        this.props.shipment.dates.deliveryTimeIn
      )
        updateData.append(
          "delInTime",
          moment(this.state.shipment.dates.deliveryTimeIn, "HH:mm").format(
            "HH:mm:ss"
          )
        );
      // Actual Delivery Time Out
      if (
        this.state.shipment.dates.deliveryTimeOut !==
        this.props.shipment.dates.deliveryTimeOut
      )
        updateData.append(
          "delOutTime",
          moment(this.state.shipment.dates.deliveryTimeOut, "HH:mm").format(
            "HH:mm:ss"
          )
        );

      // Signed By
      if (this.state.shipment.signedBy !== this.props.shipment.signedBy)
        updateData.append("signedBy", this.state.shipment.signedBy);
      // Billed cost
      if (
        this.props.showFields.includes("billedCost") &&
        this.state.shipment.charges.billedCost !==
        this.props.shipment.charges.billedCost
      ) {
        const _billed = parseFloat(this.state.shipment.charges.billedCost);
        const _billedPrev = parseFloat(this.props.shipment.charges.billedCost);
        const _estFromList = this.state.shipment.chargesList?.find(c => c.type === "estimatedCost")?.total;
        const _estimated = parseFloat(_estFromList ?? this.state.shipment.charges.estimatedCost);
        const _valueActuallyChanged = _billed !== _billedPrev;
        const _auroraOverBilling = this.context.clientCode === "aurora" && _valueActuallyChanged && !isNaN(_billed) && !isNaN(_estimated) && _billed > _estimated;
        console.log("[billedCost] clientCode:", this.context.clientCode, "| billed:", _billed, "| billedPrev:", _billedPrev, "| valueActuallyChanged:", _valueActuallyChanged, "| estimated:", _estimated, "| estFromList:", _estFromList, "| auroraOverBilling:", _auroraOverBilling, "| shipment.charges:", this.state.shipment.charges);
        if (!_auroraOverBilling) {
          console.log("[billedCost] appending billedCost to formData:", this.state.shipment.charges.billedCost);
          updateData.append(
            "billedCost",
            this.state.shipment.charges.billedCost.toString()
          );
        } else {
          console.log("[billedCost] BLOCKED from formData — aurora over-billing detected, flagging modal pending");
          this._auroraModalPending = true;
        }
      }

      // Debug FormData
      // for (var pair of updateData.entries()) {
      //   console.log("debug FormData", pair[0] + ", " + pair[1]);
      // }

      // Submit data to API:

      // UpdateShipment.UpdateStatus(updateData);
      // UpdateShipmentStatus.UpdateShipmentStatus2(updateData);
      resolve(updateData);
      //add callback for some level of verification
      // Need a time out here as the database sometimes isn't updated / return the updated data submitted in UpDateStatus if we call for the shipment data from the shipment API.  Probabbly a Coldfusion vs Node API speed thing
      // setTimeout(this.localUpDateSingleShipment, 3000);
      // Confirmation message that updates were sent
      // setTimeout(this.showUpdateAlert, 5000);
      // this.setState({ shipmentUpdateAlert: "show" });
    });
  }

  localUpDateSingleShipment() {
    let bol = this.props.shipment.id;
    this.props.updateSingleShipment(bol);
  }

  showUpdateAlert() {
    this.setState({ updateAlertStatus: "show" });
  }

  setShipmentStatus(event) {
    // console.log("setShipmentStatus fired");
    this.setState({ shipmentStatus: event.target.name });
  }

  genericModalShow() {
    this.setState({
      showGenericModal: true,
    });
  }

  genericModalHide() {
    this.setState({
      showGenericModal: false,
      genericModalTitle: "Default Text",
      genericModalBody: "Default Text",
    });
  }

  // For show / hide checkboxes for group updates / table view updates
  tableEditModeOnOffCard() {
    if (this.props.tableEditMode) {
      this.setState({
        showHideCheckBoxForTableEditMode: "checkShipmentBoxShow",
        arrowWidth: 1,
      });
    } else {
      this.setState({
        showHideCheckBoxForTableEditMode: "checkShipmentBoxHide",
        arrowWidth: 2,
      });
    }
  }

  tableEditCheckEvent(event) {
    let shipmentId = event.target.value;
    this.setState(
      (prevState) => ({
        tableSelect: !prevState.tableSelect,
      }),
      () => this.props.handleChangeTableItem(shipmentId, this.state.tableSelect)
    );
  }
  // This just makes a hash for the HTML ID for the checkboxes to use.   Some orders will appear multiple times and we need to differenetiate the HTML IDs purely for the purpose of not duplicating HTML IDs
  hashForTableEditCheckboxID() {
    var idHash =
      Math.random().toString(36).substring(2, 15) +
      Math.random().toString(36).substring(2, 15);
    this.setState({ checkBoxIDHash: idHash });
  }


  _wrappedRefreshShippments(...args) {
    if (this._deferRefresh) {
      console.log("[_wrappedRefreshShippments] deferred — aurora modal is open, will refresh on close");
      this._deferredRefreshArgs = args;
      return;
    }
    this.props.refreshShippments(...args);
  }

  updateWasSubmittedIncrement() {
    this.setState({ updateWasSubmitted: this.state.updateWasSubmitted + 1 }, () => {
      console.log("[updateWasSubmittedIncrement] _auroraModalPending:", this._auroraModalPending, "| clientCode:", this.context.clientCode);
      if (this._auroraModalPending) {
        this._auroraModalPending = false;
        this._deferRefresh = true;
        this.setState({ showAuroraBillingModal: true });
      }
    });
  }



  condRenderCardBodyDetail() {
    return (
      <div>
        <div className="row cardBodyRow2">
          <div className="col-12 col-md-3">
            {/* Equipment, weight, distance */}
            <SCC.LoadDetails userData={this.context} shipment={this.props.shipment} shipmentObjUpdateEvent={this.shipmentObjUpdateEvent} BilledMilesEdit={this.showHilightOrHide("BilledMilesEdit")} />
            {/* HU and HU dimensions */}
            <SCC.Packages render="show" shipment={this.props.shipment} />
            {/* Custom Field 10161 */}
            <SCC.CF10161 shipment={this.props.shipment} />
          </div>

          <div className="col-12 col-md-3">
            <SCC.PickupAddress shipment={this.props.shipment} language={this.state.language} />
          </div>
          <div className="col-md-1 d-none d-md-block" />
          <div className="col-12 col-md-3">
            <SCC.DeliveryAddress shipment={this.props.shipment} language={this.state.language} />
          </div>

          <div className="col-12 col-md-2">

            {/* Charges */}
            {this.showHilightOrHide("RequestAccessorials") === "show" ?
              <SCC.ChargesV2 shipment={this.props.shipment} /> :
              <SCC.ChargesV1 shipment={this.state.shipment} paymentStatusHide={this.showHilightOrHide("paymentStatus")} shipmentV4={this.state.shipmentV4} />}



            <SCC.RateAgreementDoc shipment={this.props.shipment} render={this.showHilightOrHide("rateAgreementTopHilightHide")} />
            <SCC.PickupRequestDoc shipment={this.props.shipment} render={this.showHilightOrHide("pickupRequestTopHilightHide")} />
            <SCC.TripManifest shipment={this.props.shipment} render={this.props.showFields.includes("tripManifestTopHilightHide")} />
            <SCC.BillOfLading shipment={this.props.shipment} render={this.props.showFields.includes("billOfLadingTopHilightHide")} />
          </div>
        </div>

        {/* <SCC.ConsigeeDocs shipment={this.props.shipment} /> */}


        {this.showHilightOrHide("scheduleAppointmentHilightHide") !== "hide" || this.showHilightOrHide("billingThridPartyCollectHilightHide") !== "hide" ?
          <div className="row cardBodyRow3 mt-3">
            {this.state.dockSchedulerQualification ? <SCC.DockSchedulerLink
              render={this.showHilightOrHide("scheduleAppointmentHilightHide")}
              link={this.props.shipment.loadDetails.appointmentLink}
              status={this.props.shipment.status.statusId}
              pickupApptDate={this.state.shipment.dates.appointmentPickupDate}
              shipment={this.props.shipment}
            /> : null}


            <div className="col-6 d-none d-md-block"> </div>
            <div className="col-12 col-md-3">
              {" "}
              <SCC.BillingThirdPartyCollect
                billTo={this.props.shipment.billTo}
                render={this.showHilightOrHide("billingThridPartyCollectHilightHide")}
              />
            </div>
          </div>
          : null}


        <KwikTripLiveDropNotice shipment={this.props.shipment} />

        <InovataUSDARequired shipment={this.props.shipment} />

        <AuroraBilledCostModal
          shipment={this.state.shipment}
          show={this.state.showAuroraBillingModal}
          onHide={() => {
            this._deferRefresh = false;
            this.setState({ showAuroraBillingModal: false });
            if (this._deferredRefreshArgs !== undefined) {
              const args = this._deferredRefreshArgs;
              this._deferredRefreshArgs = undefined;
              this.props.refreshShippments(...args);
            }
          }}
        />


        {(this.props.shipment.customerId === "Schuff" && this?.props?.shipment?.customFields && this?.props?.shipment?.customFields.length && this?.props?.shipment?.customFields.filter(customField => customField.fieldId === 119).length > 0) || this.props.shipment.shipper.bolNotes || this.props.shipment.consignee.bolNotes ?
          <div className="row mt-3">
            {this.props.shipment.customerId === "Schuff" && this?.props?.shipment?.customFields && this?.props?.shipment?.customFields.length && this?.props?.shipment?.customFields.filter(customField => customField.fieldId === 119).length > 0 ?

              <div className="col">
                {this?.props?.shipment?.customFields.map(shipment => {
                  if (shipment.fieldId === 119 && shipment.value !== null && shipment.value !== "") {
                    return (
                      <div className="mt-2 mb-2">
                        <span className="font-weight-bold">BOL Note:</span>{" "}
                        <span>{shipment.value}</span>
                        <br />
                      </div>

                    )
                  }
                  return null;
                })}
              </div>
              : null}
            {this.props.shipment.shipper.bolNotes ? (
              <div className="col">
                <span className="font-weight-bold">Pickup Note:</span>{" "}
                {this.props.shipment.shipper.bolNotes}
                <br />
              </div>
            ) : null}
          </div>
          : null}

        {this.props.shipment.consignee.bolNotes ?
          <div className="row mt-3">
            {this.props.shipment.consignee.bolNotes ? (
              <div className="col">
                <div className="mt-2 mb-2">
                  <span className="font-weight-bold">Delivery Note:</span>{" "}
                  {this.props.shipment.consignee.bolNotes}
                  <br />
                </div>
              </div>
            ) : null}
          </div>
          : null}
        <div className="row">
          <div className="col" />
        </div>
      </div>
    );

  }

  condRenderAcceptDeclineTender() {
    if (this.showHilightOrHide("tenderAcceptDecline") !== "hide") {
      // If Dockscheduler link is present
      if (this.props.shipment.loadDetails.appointmentLink !== null && this.props.shipment.customerId !== "kissner" && this.state.dockSchedulerQualification) {
        return (
          <div>
            <div className="row mt-3">
              {/* Accept / Decline Tender buttons */}
              <div className={`col-12 col-md-auto mr-3 ${this.showHilightOrHide("tenderAcceptDecline")}`}>
                <a
                  href={`${this.props.shipment.loadDetails.appointmentLink}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button
                    type="button"
                    className="btn btn-outline-success btn-block"
                    onClick={this.handleAcceptShipment}
                    disabled={this.state.tenderAcceptDeclineButtonsDisabled}
                  >
                    Accept & Schedule Appointment
                  </button>
                </a>
              </div>
              <div className={`col-12 col-md-auto ${this.showHilightOrHide("tenderAcceptDecline")}`}>
                <button
                  type="button"
                  className="btn btn-outline-danger btn-block"
                  onClick={this.handleDeclineShipment}
                  disabled={this.state.tenderAcceptDeclineButtonsDisabled}
                >
                  Decline <br />
                  Tender
                  <br />
                  &nbsp;
                </button>
              </div>
            </div>
          </div>
        );
      } else {
        // If no dock scheduler link
        return (
          <div>

            <div className="row mt-3">
              {/* Accept / Decline Tender buttons */}
              <div className="col-12 col-md-auto">
                <div className={`${this.showHilightOrHide("tenderAcceptDecline")}`} style={{ textAlign: 'center' }}>
                  <button
                    type="button"
                    className="btn btn-outline-success"
                    onClick={this.handleAcceptShipment}
                    disabled={this.state.tenderAcceptDeclineButtonsDisabled}
                  >
                    Accept Tender
                  </button>
                </div>
              </div>
              <div className="col-12 col-md-auto">
                <div className={`${this.showHilightOrHide("tenderAcceptDecline")}`} style={{ textAlign: 'center' }}>
                  <button
                    type="button"
                    className="btn btn-outline-danger"
                    style={{ padding: "0.5rem 0.5rem" }}
                    onClick={this.handleDeclineShipment}
                    disabled={this.state.tenderAcceptDeclineButtonsDisabled}
                  >
                    Decline Tender
                  </button>
                </div>
                {/*
                Send Email testing
              */}
                {/* {this.showHilightOrHide('sendPUEmailOnAccept') === "show" ?
                  <button onClick={(event) => SendEmail(this.props.shipment, this.context)}>Send Email Testing</button>
                  : null
                } */}
              </div>
              <div className="col-12 col-md-auto">
                <AcceptDeclineStatus status={this.state.acceptDeclineStatusState} />
              </div>
            </div>
          </div>
        );
      }
    } else {
      return null;
    }
  }

  condRenderAcceptDeclineLoadChanges() {
    if (this.showHilightOrHide("loadChangesAcceptDecline") !== "hide") {
      return (
        <div>
          <div className="row mt-3">
            <div className="col-12 col-md-auto">
              <div className={`${this.showHilightOrHide("loadChangesAcceptDecline")}`}>
                <button
                  type="button"
                  className="btn btn-outline-success"
                  onClick={this.handleAcceptShipmentChanges}
                >
                  Accept Load Changes
                </button>
              </div>
            </div>
            <div className="col-12 col-md-auto">
              <div className={`${this.showHilightOrHide("loadChangesAcceptDecline")}`}>
                <button
                  type="button"
                  className="btn btn-outline-danger"
                  onClick={this.handleDeclineShipmentChanges}
                >
                  Decline Load Changes
                </button>
              </div>
            </div>

            <div className="col-12 col-md-auto">
              <AcceptDeclineStatus status={this.state.acceptDeclineStatusState} />
            </div>
            {/* <Col xs lg="3" className={this.state.acceptDeclineUpdateAlertSuccess}>
              <Alert variant="success">Shipment Updated!</Alert>
            </div>
            <div className={`col-12 col-md-auto ${this.state.acceptDeclineUpdateAlertFailure}`}>
              <div className="alert alert-danger" role="alert">Shipment NOT updated, please try again.</div>
            </div> */}
          </div>
        </div>
      );
    } else {
      return null;
    }
  }

  condRenderAllUpdateFields() {
    const ageCheck = isShipmentTooOldToUpdate(this.props.shipment.dates);
    if (ageCheck.tooOld) {
      return (
        <div className="form-row">
          <div className="col">
            <div className="alert alert-secondary d-flex align-items-center mt-3" role="alert">
              <span role="img" aria-label="locked" style={{ fontSize: '1.2em', marginRight: '8px' }}>🔒</span>
              <span>This shipment is too old to update.</span>
            </div>
          </div>
        </div>
      );
    }
    if (!this.props.shipment.settlementId || this.context.clientCode === "aurora") {
      let invoiceNumberPlaceHolderText = "If Different from Pro Number"
      if (this.context.clientCode === "kwiktrip" || this.context.clientCode.includes("halliburton")) {
        invoiceNumberPlaceHolderText = ""
      }
      return (
        <div
          className={`${this.showHilightOrHide(
            "allUpdateFieldsHilightHide"
          )} 'heylook'`}
        >
          <form
            className="sc-update-form"
            onSubmit={this.handleSubmitUpdateShipment}
            autoComplete="off"
          >
            {this.state.messagesIcon === "unreadMessages" ?
              <div className="form-row">
                <div className="col">
                  <SCC.UnreadMessageBox shipment={this.props.shipment} modalOpenMessaging={this.modalOpenMessaging} markMessageReadOnOpen={this.markMessageReadOnOpen} />
                </div>
              </div>
              : null}

            {this.state.updateWasSubmitted === 1 ?
              <WhatsMissingListAurora shipment={this.props.shipment} showFields={this.props.showFields} />
              : null}

            {this.props.showFields.includes("BilledCostBreakdownReadOnly") ?

              <div className="form-row">

                <SCC.BilledCostBreakdownReadOnly render={this.props.showFields.includes("BilledCostBreakdownReadOnly")} userData={this.context} shipment={this.props.shipment} />

              </div>

              : null}

            {this.showHilightOrHide("RequestAccessorialsByQty") === "show" ?
              (
                <div className="form-row">
                  <div className="col">
                    <SCC.AccessorialRequestsByQty userData={this.context} shipment={this.props.shipment} />
                  </div>
                </div>
              )
              : null}


            {this.showHilightOrHide("RequestAccessorials") === "show" ?
              <div className="form-row">
                <div className="col mt-3">
                  <SCC.AccessorialRequest userData={this.context} newAccesorialRequests={this.state.newAccesorialRequests} addAccessorialRequest={this.addAccessorialRequest} clearAddedAccessorials={this.clearAddedAccessorials} shipment={this.props.shipment} showOrHide={this.showHilightOrHide("RequestAccessorials")} inputFieldsReadOnly={this.state.inputFieldsReadOnly} language={this.state.language} />
                </div>
              </div>
              : null}

            {(this.showHilightOrHide("statusBtns") === "show" || this.showHilightOrHide("statusBtns") === "hilight" || this.props.showFields.includes("GPSInfo")) ?
              <div className="form-row mt-3">
                <div class="col-auto">

                  <SCC.ShipmentStatus
                    shipment={this.state.shipment} statusBtns={this.showHilightOrHide("statusBtns")} shipmentObjUpdateEvent={this.shipmentObjUpdateEvent} statusBtnsHilightHide={this.showHilightOrHide("statusBtns")} statusBtnShowHidePuOut={this.showHilightOrHide("statusBtnShowHidePuOut")} statusBtnShowHideIT={this.showHilightOrHide("statusBtnShowHideIT")} statusBtnShowHideITDelayed={this.showHilightOrHide("statusBtnShowHideITDelayed")} statusBtnShowHideOFD={this.showHilightOrHide("statusBtnShowHideOFD")} statusBtnShowHideDEL={this.showHilightOrHide("statusBtnShowHideDEL")}
                    statusBtnShowHideScheduled={this.props.showFields.includes("statusBtnShowHideScheduled")}
                    inputFieldsReadOnly={this.state.inputFieldsReadOnly} language={this.state.language}
                    lockToDeliveredOnly={this.auroraSettlementFieldsLocked()}
                  />


                </div>
                {this.props.showFields.includes("GPSInfo") ?
                  <div class="col-auto">
                    <SCC.GPSInfo shipment={this.state.shipment} />
                  </div>
                  : null}
              </div>
              : null}

            {this.showHilightOrHide("carrierNameInput") !== "hide" ?
              <div className="form-row mt-3">
                <div className="col">
                  <SCC.CarrierName
                    carrierName={this.state.shipment.carrierName}
                    shipmentObjUpdateEvent={this.shipmentObjUpdateEvent}
                    showOrHide={this.showHilightOrHide("carrierNameInput")}
                  />
                </div>

              </div>
              : null}

            {this.showHilightOrHide("truckNumber") !== "hide" || this.showHilightOrHide("trailerNumber") !== "hide" || this.showHilightOrHide("driverPhone") !== "hide" || this.showHilightOrHide("invoiceDateHilightHide") !== "hide" ?
              <div className="form-row mt-3">
                <SCC.TruckNumber shipmentObjUpdateEvent={this.shipmentObjUpdateEvent}
                  value={this.state.shipment.loadDetails.truckNumber} userData={this.context}
                  hilightHide={this.showHilightOrHide("truckNumber")}
                />
                <SCC.TrailerNumber shipmentObjUpdateEvent={this.shipmentObjUpdateEvent}
                  value={this.state.shipment.loadDetails.trailerNumber} userData={this.context}
                  hilightHide={this.showHilightOrHide("trailerNumber")}
                />
                <SCC.DriverPhone shipmentObjUpdateEvent={this.shipmentObjUpdateEvent}
                  value={this.state.shipment.loadDetails.driverPhone} userData={this.context}
                  hilightHide={this.showHilightOrHide("driverPhone")}
                />
                <div className={`col col-lg-2 ${this.showHilightOrHide("invoiceDateHilightHide")}`}>
                  <SCC.InvoiceDateFormField
                    render="show"
                    value={this.state.invoiceDate}
                    onChange={this.handleChangeGeneric}
                  />
                </div>
              </div>
              : null}

            <div className="form-row mt-3">

              {this.showHilightOrHide("appointmentPickupDate") === 'show' ?
                (
                  <div className={`form-group col col-lg-2 ${this.showHilightOrHide("appointmentPickupDate")}`}>
                    <label>Appt. Pickup:</label>
                    <input
                      className="form-control form-control-sm"
                      name="dates.appointmentPickupDate"
                      onChange={this.shipmentObjUpdateEvent}
                      type="date"
                      value={moment(
                        this.state.shipment.dates.appointmentPickupDate
                      ).format("YYYY-MM-DD")}
                    />
                  </div>
                ) : null
              }


              <SCC.PUApptDateLimited
                render={this.props.showFields.includes("appointmentPickupDateLimited")}
                apptPUDate={moment(
                  this.state.shipment.dates.appointmentPickupDate
                ).format("YYYY-MM-DD")}
                shipmentObjUpdateEvent={this.shipmentObjUpdateEvent}
                availableDate1={this.state.shipment.dates.availableDate1}
                inputFieldsReadOnly={this.state.inputFieldsReadOnly}
              />

              {this.showHilightOrHide("appointmentPickupTimeIn") === 'show' ?
                (
                  <div className={`form-group col col-lg-2 ${this.showHilightOrHide("appointmentPickupTimeIn")}`}>
                    <label>Time In: </label>
                    <input
                      className="form-control form-control-sm"
                      name="dates.appointmentPickupTimeIn"
                      onChange={this.shipmentObjUpdateEvent}
                      type="time"
                      value={this.state.shipment.dates.appointmentPickupTimeIn}
                      disabled={this.state.inputFieldsReadOnly}
                    />
                  </div>
                ) : null}

              {this.showHilightOrHide("appointmentPickupTimeOut") === 'show' ?
                (
                  <div className={`form-group col col-lg-2 ${this.showHilightOrHide("appointmentPickupTimeOut")}`}>
                    <label>Time Out:</label>
                    <input
                      className="form-control form-control-sm"
                      name="dates.appointmentPickupTimeOut"
                      onChange={this.shipmentObjUpdateEvent}
                      type="time"
                      value={this.state.shipment.dates.appointmentPickupTimeOut}
                      disabled={this.state.inputFieldsReadOnly}
                    />
                  </div>
                ) : null}

              <SCC.PickupETA
                render={this.props.showFields.includes("estpudate")}
                value={this.state.shipment.dates.estimatedPickup}
                onChange={this.shipmentObjUpdateEvent}
                shipment={this.state.shipment}
                inputFieldsReadOnly={this.state.inputFieldsReadOnly}
              />

              <SCC.PickupETA_Time
                render={this.props.showFields.includes("estputime")}
                value={this.state.shipment.dates.estimatedPickupTime}
                onChange={this.shipmentObjUpdateEvent}
                inputFieldsReadOnly={this.state.inputFieldsReadOnly}
              />
            </div>
            <div className="form-row">


              {this.showHilightOrHide("appointmentDeliveryDate") === 'show' ?

                (
                  <div className="form-group col col-lg-2">
                    <label>Appt. Delivery:</label>
                    <input
                      className="form-control form-control-sm"
                      name="dates.appointmentDeliveryDate"
                      onChange={this.shipmentObjUpdateEvent}
                      type="date"
                      value={moment(
                        this.state.shipment.dates.appointmentDeliveryDate
                      ).format("YYYY-MM-DD")}
                      disabled={this.state.inputFieldsReadOnly}
                    />
                  </div>
                ) : null}

              <SCC.DELApptDateLimited
                render={this.props.showFields.includes("appointmentDeliveryDateLimited")}
                apptDelDate={moment(
                  this.state.shipment.dates.appointmentDeliveryDate
                ).format("YYYY-MM-DD")}
                shipmentObjUpdateEvent={this.shipmentObjUpdateEvent}
                requestedDeliveryDate={this.state.shipment.dates.requestedDeliveryDate}
                inputFieldsReadOnly={this.state.inputFieldsReadOnly}
              />

              {this.showHilightOrHide("appointmentDeliveryTimeIn") === 'show' ?
                (
                  <div className={`form-group col col-lg-2 ${this.showHilightOrHide("appointmentDeliveryTimeIn")}`}>
                    <label>Time In:</label>
                    <input
                      className="form-control form-control-sm"
                      name="dates.appointmentDeliveryTimeIn"
                      onChange={this.shipmentObjUpdateEvent}
                      type="time"
                      value={this.state.shipment.dates.appointmentDeliveryTimeIn}
                      disabled={this.state.inputFieldsReadOnly}
                    />
                  </div>
                ) : null}

              {this.showHilightOrHide("appointmentDeliveryTimeOut") === 'show' ?
                (
                  <div className={`form-group col col-lg-2 ${this.showHilightOrHide("appointmentDeliveryTimeOut")}`}>
                    <label>Time Out:</label>
                    <input
                      className="form-control form-control-sm"
                      name="dates.appointmentDeliveryTimeOut"
                      onChange={this.shipmentObjUpdateEvent}
                      type="time"
                      value={this.state.shipment.dates.appointmentDeliveryTimeOut}
                      disabled={this.state.inputFieldsReadOnly}
                    />
                  </div>
                ) : null}

              <SCC.DeliveryETA
                render={this.props.showFields.includes("deliveryETA")}
                name="dates.estimatedDelivery"
                onChange={this.shipmentObjUpdateEvent}
                value={this.state.shipment.dates.estimatedDelivery}
                inputFieldsReadOnly={this.state.inputFieldsReadOnly}
              />

              <SCC.DeliveryETA_Time
                render={this.props.showFields.includes("estdeltime")}
                name="dates.estimatedDeliveryTime"
                onChange={this.shipmentObjUpdateEvent}
                value={this.state.shipment.dates.estimatedDeliveryTime}
                inputFieldsReadOnly={this.state.inputFieldsReadOnly}
              />


            </div>

            <div className="form-row">
              <div className={`form-group col col-lg-2 ${this.showHilightOrHide("actualPickupDate")}`}>
                <label>
                  {this.state.language && this.state.language.code === "es" ? "Recogida Real:" : "Actual Pickup:"}
                </label>
                <input
                  className="form-control form-control-sm"
                  name="dates.pickupDate"
                  onChange={this.shipmentObjUpdateEvent}
                  type="date"
                  value={moment(this.state.shipment.dates.pickupDate).format(
                    "YYYY-MM-DD"
                  )}
                  disabled={this.state.inputFieldsReadOnly}
                />
              </div>
              <div className={`form-group col col-lg-2 ${this.showHilightOrHide("estimatedDeliveryDate")}`}>
                <label>Est. Del Date:</label>
                <input
                  className="form-control form-control-sm"
                  name="dates.estimatedDeliveryDate"
                  onChange={this.shipmentObjUpdateEvent}
                  type="date"
                  value={moment(
                    this.state.shipment.dates.estimatedDeliveryDate
                  ).format("YYYY-MM-DD")}
                  disabled={this.state.inputFieldsReadOnly}
                />
              </div>
              <div className={`form-group col col-lg-2 ${this.showHilightOrHide("actualPickupTimeIn")}`}>
                <label>
                  {this.state.language && this.state.language.code === "es" ? "Hora Entrada:" : "Time In:"}
                </label>
                <input
                  className="form-control form-control-sm"
                  name="dates.pickupTimeIn"
                  onChange={this.shipmentObjUpdateEvent}
                  type="time"
                  value={this.state.shipment.dates.pickupTimeIn}
                  disabled={this.state.inputFieldsReadOnly}
                />
              </div>
              <div className={`form-group col col-lg-2 ${this.showHilightOrHide("actualPickupTimeOut")}`}>
                <label>
                  {this.state.language && this.state.language.code === "es" ? "Hora Salida:" : "Time Out:"}
                </label>
                <input
                  className="form-control form-control-sm"
                  name="dates.pickupTimeOut"
                  onChange={this.shipmentObjUpdateEvent}
                  type="time"
                  value={moment(
                    this.state.shipment.dates.pickupTimeOut,
                    "HH:mm:ss"
                  ).format("HH:mm")}
                  disabled={this.state.inputFieldsReadOnly}
                />
              </div>
              <div className={`form-group col col-lg-2 ${this.showHilightOrHide("actualDeliveryDate")}`}>
                <label>
                  {this.state.language && this.state.language.code === "es" ? "Entrega Real:" : "Actual Delivery:"}
                </label>
                <input
                  className="form-control form-control-sm"
                  name="dates.deliveryDate"
                  onChange={this.shipmentObjUpdateEvent}
                  type="date"
                  value={
                    this.state.shipment.dates.deliveryDate === null
                      ? ""
                      : moment(this.state.shipment.dates.deliveryDate).format(
                        "YYYY-MM-DD"
                      )
                  }
                  disabled={this.state.inputFieldsReadOnly}
                />
                {(this.context.clientCode === "aurora" || this.context.clientCode === "acmebumn") &&
                  this.state.shipment.dates.pickupDate &&
                  this.state.shipment.dates.deliveryDate &&
                  moment(this.state.shipment.dates.deliveryDate).diff(moment(this.state.shipment.dates.pickupDate), 'days') >= 10 &&
                  <small style={{ color: '#e67e00' }}>⚠ 10+ day transit time</small>
                }
              </div>

              <div className={`form-group col col-lg-2 ${this.showHilightOrHide("actualDeliveryTimeIn")}`}>
                <label>
                  {this.state.language && this.state.language.code === "es" ? "Hora Entrada:" : "Time In:"}
                </label>
                <input
                  className="form-control form-control-sm"
                  name="dates.deliveryTimeIn"
                  onChange={this.shipmentObjUpdateEvent}
                  type="time"
                  value={moment(
                    this.state.shipment.dates.deliveryTimeIn,
                    "HH:mm:ss"
                  ).format("HH:mm")}
                  disabled={this.state.inputFieldsReadOnly}
                />
              </div>

              <div className={`form-group col col-lg-2 ${this.showHilightOrHide("actualDeliveryTimeOut")}`}>
                <label>
                  {this.state.language && this.state.language.code === "es" ? "Hora Salida:" : "Time Out:"}
                </label>
                <input
                  className="form-control form-control-sm"
                  name="dates.deliveryTimeOut"
                  onChange={this.shipmentObjUpdateEvent}
                  type="time"
                  value={moment(
                    this.state.shipment.dates.deliveryTimeOut,
                    "HH:mm:ss"
                  ).format("HH:mm")}
                  disabled={this.state.inputFieldsReadOnly}
                />
              </div>
            </div>
            <div className={`form-row ${this.showHilightOrHide("documents")}`}>
              <div className="col font-weight-bold mb-0">
                  {this.state.language && this.state.language.code === "es" ? "Documentos" : "Documents"}
              </div>
            </div>
            <div className={`form-row ${this.showHilightOrHide("documents")} mb-2`}>


              {this.props.shipment?.stops && this.props.showFields.includes("UploadDocsPerStop") ? (null) : (
                <div className="col-12 col-lg-3">
                  <select
                    className="custom-select custom-select-sm"
                    as="select"
                    size="sm"
                    onChange={this.documentUploadHandleChangeDocSelect}
                    value={this.state.documentUploadFileType || ""}
                  >
                    <option value="">
                      {this.state.language && this.state.language.code === "es" ? "Seleccionar Tipo de Documento" : "Select Document Type"}
                    </option>
                    {this.props.documents === undefined ? (
                      <>
                        {this.context.clientCode === "foremost" ? <option value="AccRec">Accessorial Receipt</option> : null}
                        <option value="b3">B3</option>
                        <option value="BOL">BOL</option>
                        <option value="invoice">Invoice</option>
                        <option value="Signed-BOL"> Signed Bill of Lading</option>
                        <option value="Signed-BOLandInvoice">
                          Signed BOL & Invoice
                        </option>
                        {this.context.clientCode === "armetals" || this.context.clientCode === "fishinco" ? <option value="POD">POD</option> : null}
                        {this.context.clientCode === "armetals" ? <option value="Supplementary-Documents">Supplementary Documents</option> : null}
                        {this.context.clientCode === "alanwire" ?
                          <option value="Consignee-SignedBOL">
                            Consignee Signed BOL
                          </option> : null}
                      </>
                    ) : (
                      this.props.documents && this.props.documents.map((document, index) => (
                        <option key={index} value={document.value}>
                          {document.label}
                        </option>
                      ))
                    )}

                  </select>
                </div>
              )}



              {this.props.shipment?.stops && this.props.showFields.includes("UploadDocsPerStop") ? (null)
                :
                (
                  <div className="col-12 col-lg-3">
                    <label className="form-control form-control-sm" style={{cursor: 'pointer', marginBottom: 0}}>
                      <input
                        size="sm"
                        type="file"
                        accept={AcceptedUploadTypes}
                        name="file"
                        // ref={this.fileInput}
                        onChange={this.documentUploadFileChangeHandler}
                      />
                      {this.state.documentUploadFileName
                        ? this.state.documentUploadFileName
                        : "Choose File"}
                    </label>

                  </div>
                )

              }

              <div className="col-auto col-lg-2">
                <button
                  className="btn btn-outline-info whiteBackgroundBtn"
                  onClick={this.modalOpenDocs}
                >
                  Documents &nbsp;
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-file-earmark" viewBox="0 0 16 16">
                    <path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5z" />
                  </svg>
                </button>
                <SCC.DocumentsModal
                  show={this.state.docsModalShow}
                  isUploadDocsPerStop={this.props.showFields.includes("UploadDocsPerStop")}
                  onHide={this.onHideDocs}
                  onHideDocs={this.onHideDocs}
                  id={this.props.shipment.id}
                  documents={this.props.shipment.documents}
                  updateWasSubmitted={this.state.updateWasSubmitted}
                  shipment={this.props.shipment}
                />
              </div>

              <div className="col">
                {/* GenericModal is placed here for no reason, it has to be somewhere on this page but is not visible on the ShipmentCard */}
                <SCC.GenericModal
                  show={this.state.showGenericModal}
                  title={this.state.genericModalTitle}
                  body={this.state.genericModalBody}
                  genericModalHide={this.genericModalHide}
                />
                <SCC.SchuffGPSModal
                  show={this.state.showSchuffGPSModal}
                  title={this.state.schuffGPSModalTitle}
                  body={this.state.schuffGPSModalBody}
                  displayPhoneField={this.state.schuffGPSModalDisplayPhone}
                  displayTruckField={this.state.schuffGPSModalDisplayTruck}
                  phonePlaceholderText={this.state.schuffGPSModalPhonePlaceholderText}
                  onHide={this.hideSchuffGPSModal}
                  hideSchuffGPSModal={this.hideSchuffGPSModal}
                  id={this.props.shipment.id}
                />
              </div>
            </div>
            <div className="form-row">
              <div className={`form-group col-6 col-lg-2 ${this.showHilightOrHide("billedCost")}`}>
                <label>
                  {this.state.language && this.state.language.code === "es" ? "Cargos Facturados:" : "Billed Charges:"}
                </label>
                <div className="input-group input-group-sm mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="basic-addon1">$</span>
                  </div>
                  <input
                    className="form-control"
                    name="charges.billedCost"
                    type="text"
                    aria-label="Amount"
                    value={this.state.shipment.charges.billedCost}
                    onChange={this.shipmentObjUpdateEvent}
                    disabled={this.state.inputFieldsReadOnly || this.auroraSettlementFieldsLocked()}
                  />
                </div>
              </div>
              <div className={`form-group col-12 col-lg-4 ${this.showHilightOrHide("chargesMessage")}`}>
                <>
                  <label>
                    {this.state.language && this.state.language.code === "es" ? "Notas de Cargos:" : "Charges Notes:"}
                  </label>
                  <div className="input-group input-group-sm mb-3">
                    <div className="input-group-prepend">
                      <span className="input-group-text" id="basic-addon1">
                        {" "}
                        <i className="far fa-sticky-note" />
                      </span>
                    </div>
                    <input
                      className="form-control"
                      name="chargesMessage"
                      type="text"
                      aria-label="Amount"
                      value={this.state.chargesMessage}
                      onChange={this.handleChangeGeneric}
                      disabled={this.state.inputFieldsReadOnly}
                    />
                  </div>
                </>
              </div>
              <div className={`form-group col-12 col-lg-4 ${this.showHilightOrHide("signedBy")}`}>
                <label> 
                  {this.state.language && this.state.language.code === "es" ? "Firmado Por:" : "Signed By:"}
                </label>
                <div className="input-group input-group-sm mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="basic-addon1">
                      <i className="fas fa-file-signature" />
                    </span>
                  </div>
                  <input
                    className="form-control"
                    name="signedBy"
                    type="text"
                    value={this.state.shipment.signedBy}
                    onChange={this.shipmentObjUpdateEvent}
                    disabled={this.state.inputFieldsReadOnly}
                  />
                </div>
              </div>
              <div className={`col-6 col-lg-3 ${this.showHilightOrHide("invoicePro")}`}>
                <SCC.TrackingInvoiceNumber
                  showOrHide={this.showHilightOrHide("invoicePro")}
                  clientCode={this.context.clientCode}
                  trackingNumber={this.state.shipment.charges.trackingNumber}
                  shipmentObjUpdateEvent={this.shipmentObjUpdateEvent}
                  inputFieldsReadOnly={this.state.inputFieldsReadOnly || this.auroraSettlementFieldsLocked()}
                  language={this.state.language}
                />
              </div>
              <div className={`form-group col-6 col-lg-3 ${this.showHilightOrHide("invoiceNumber2HilightHide")}`}>
                <label>Invoice Number:</label>
                <input
                  className="form-control form-control-sm"
                  type="text"
                  name="charges.invoiceNumber"
                  value={this.state.shipment.charges.invoiceNumber}
                  onChange={this.shipmentObjUpdateEvent}
                  placeholder={invoiceNumberPlaceHolderText}
                  disabled={this.state.inputFieldsReadOnly || this.auroraSettlementFieldsLocked()}
                />{" "}
                {this.state.shipment.charges.invoiceNumber === "" || this.state.inputFieldsReadOnly || this.auroraSettlementFieldsLocked() ? null : (
                  <span
                    style={{
                      cursor: "pointer",
                      color: "blue",
                      textDecoration: "underline",
                    }}
                    onClick={this.copyInvoice2ToInvoicePro}
                  >
                    <small>Copy to Invoice / Pro Number</small>
                  </span>
                )}
              </div>
            </div>
          </form>
          <div className="row">
            <div className="col">
              <SubmitUpdate
                clearAddedAccessorials={this.clearAddedAccessorials}
                newAccesorialRequests={this.state.newAccesorialRequests}
                propsShipment={this.props.shipment}
                shipment={this.state.shipment}
                setAndShowGenericModal={this.setAndShowGenericModal}
                chargesMessage={this.state.chargesMessage}
                buildFormDataForShipmentUpdate={
                  this.buildFormDataForShipmentUpdate
                }
                updatedFormData={this.state.updatedFormData}
                localUpDateSingleShipment={this.localUpDateSingleShipment}
                refreshShippments={this._wrappedRefreshShippments}
                documentUploadFile={this.state.documentUploadFile}
                documentUploadFileType={this.state.documentUploadFileType}
                documentUploadBuildFormData={this.documentUploadBuildFormData}
                disabledForm={this.state.disabledForm}
                puTimeIn={this.state.shipment.dates.pickupTimeIn}
                puOutTime={this.state.shipment.dates.appointmentPickupTimeOut}
                delInTime={this.state.shipment.dates.deliveryTimeIn}
                delOutTime={this.state.shipment.dates.deliveryTimeOut}
                updateWasSubmittedIncrement={this.updateWasSubmittedIncrement}
              // checkAndSubmitChargesNotes={this.checkAndSubmitChargesNotes}
              />
            </div>
            {this.context.clientCode === "aurora" && this.state.updateWasSubmitted > 1 ?
              <div className="col">
                <WhatsMissingListAurora shipment={this.state.shipment} showFields={this.props.showFields} />
              </div>
              : null}
            {this.props.showFields.includes("billedChargeChecklist") ?
              <div className="col">
                <SCC.BilledChargeChecklist shipment={this.state.shipment}
                  refreshShippments={this.props.refreshShippments}
                  documentUploadFile={this.state.documentUploadFile}
                  documentUploadFileType={this.state.documentUploadFileType}
                  documentUploadBuildFormData={this.documentUploadBuildFormData}
                  buildFormDataForShipmentUpdate={
                    this.buildFormDataForShipmentUpdate
                  }
                  accessoralRequestFeatureExists={this.showHilightOrHide("RequestAccessorials")}
                  updateWasSubmitted={this.state.updateWasSubmitted}
                />
              </div>
              : null}
            <hr />
          </div>
          {this.state.disabledForm === "disabled" ? <div className="row">
            <div className="col"> <div className="alert alert-secondary d-inline-block" role="alert">This shipment is in OK status.  It cannot be updated.</div> </div></div> : null}


          {/* 
            ADVANCED BILLING SECTION (uses the billed cost modal from shippersEdge)
          */}
        
          {this.props.showFields.includes("billedCostDetails") && ["americanwater","bascohq","deezcats","DemoAllenFlavors","dlfcanada","exportpackers","fishinco","flogistix","foremost","foremostTesting","hoodcontainer","inovatafoods","inovatafoodsTesting","kwiktrip","kwiktrip-staging","nateh","rembrandtfoods","sleepcountry","suburbanWaste","swegon"].includes(this.context.clientCode) ?
            <>
              <div className="row">
                <div className="col">
                  <hr />
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <h5 class="">Billing</h5>
                </div>
              </div>
              <div className="row">
                <SCC.BilledChargeEditInDetail shipment={this.state.shipment}
                  refreshShippments={this.props.refreshShippments}
                  documentUploadFile={this.state.documentUploadFile}
                  documentUploadFileType={this.state.documentUploadFileType}
                  documentUploadBuildFormData={this.documentUploadBuildFormData}
                  buildFormDataForShipmentUpdate={
                    this.buildFormDataForShipmentUpdate
                  }
                  accessoralRequestFeatureExists={this.showHilightOrHide("RequestAccessorials")}
                  updateWasSubmitted={this.state.updateWasSubmitted}
                />
              </div>
            </>
            : null}

          {this.props.showFields.includes("BilledChargeEditIndetail2") ?
            <>
              <div className="row">
                <div className="col">
                  <hr />
                </div>
              </div>
              <div className="row">
                <SCC.BilledChargeEditIndetail2 shipment={this.state.shipment}
                  refreshShippments={this.props.refreshShippments}
                  documentUploadFile={this.state.documentUploadFile}
                  documentUploadFileType={this.state.documentUploadFileType}
                  documentUploadBuildFormData={this.documentUploadBuildFormData}
                  buildFormDataForShipmentUpdate={
                    this.buildFormDataForShipmentUpdate
                  }
                  accessoralRequestFeatureExists={this.showHilightOrHide("RequestAccessorials")}
                  updateWasSubmitted={this.state.updateWasSubmitted}
                />
              </div> </> : null}

        </div>
      );
    } else {
      // Shipment is settled (and client isn't aurora, which gets the full form
      // with field-level locking instead - see auroraSettlementFieldsLocked()).
      // The rest of the update form stays hidden, but document uploads should
      // still be allowed, so that section is rendered here on its own,
      // independent of the SubmitUpdate "Update Shipment" button/form above.
      const isPerStopUpload = this.props.shipment?.stops && this.props.showFields.includes("UploadDocsPerStop");
      return (
        <div>
          {this.showHilightOrHide("RequestAccessorialsByQty") === "show" ? (
            <div className="form-row">
              <div className="col">
                <SCC.AccessorialRequestsByQty userData={this.context} shipment={this.props.shipment} />
              </div>
            </div>
          ) : null}

          <div className="form-row">
            <div className="col">
              <div className="alert alert-secondary d-flex align-items-center mt-3" role="alert">
                <span role="img" aria-label="locked" style={{ fontSize: '1.2em', marginRight: '8px' }}>🔒</span>
                <span>
                  {this.state.language && this.state.language.code === "es"
                    ? "Este envío ha sido liquidado y ya no se puede actualizar, pero aún puede subir documentos a continuación."
                    : "This shipment has been settled and can no longer be updated, but you can still upload documents below."}
                </span>
              </div>
            </div>
          </div>

          <div className={`form-row ${this.showHilightOrHide("documents")}`}>
            <div className="col font-weight-bold mb-0">
              {this.state.language && this.state.language.code === "es" ? "Documentos" : "Documents"}
            </div>
          </div>
          <div className={`form-row ${this.showHilightOrHide("documents")} mb-2`}>
            {isPerStopUpload ? null : (
              <div className="col-12 col-lg-3">
                <select
                  className="custom-select custom-select-sm"
                  as="select"
                  size="sm"
                  onChange={this.documentUploadHandleChangeDocSelect}
                  value={this.state.documentUploadFileType || ""}
                >
                  <option value="">
                    {this.state.language && this.state.language.code === "es" ? "Seleccionar Tipo de Documento" : "Select Document Type"}
                  </option>
                  {this.props.documents === undefined ? (
                    <>
                      {this.context.clientCode === "foremost" ? <option value="AccRec">Accessorial Receipt</option> : null}
                      <option value="b3">B3</option>
                      <option value="BOL">BOL</option>
                      <option value="invoice">Invoice</option>
                      <option value="Signed-BOL"> Signed Bill of Lading</option>
                      <option value="Signed-BOLandInvoice">
                        Signed BOL & Invoice
                      </option>
                      {this.context.clientCode === "armetals" || this.context.clientCode === "fishinco" ? <option value="POD">POD</option> : null}
                      {this.context.clientCode === "armetals" ? <option value="Supplementary-Documents">Supplementary Documents</option> : null}
                      {this.context.clientCode === "alanwire" ?
                        <option value="Consignee-SignedBOL">
                          Consignee Signed BOL
                        </option> : null}
                    </>
                  ) : (
                    this.props.documents && this.props.documents.map((document, index) => (
                      <option key={index} value={document.value}>
                        {document.label}
                      </option>
                    ))
                  )}
                </select>
              </div>
            )}

            {isPerStopUpload ? null : (
              <div className="col-12 col-lg-3">
                <label className="form-control form-control-sm" style={{ cursor: 'pointer', marginBottom: 0 }}>
                  <input
                    size="sm"
                    type="file"
                    accept={AcceptedUploadTypes}
                    name="file"
                    onChange={this.documentUploadFileChangeHandler}
                  />
                  {this.state.documentUploadFileName
                    ? this.state.documentUploadFileName
                    : "Choose File"}
                </label>
              </div>
            )}

            {isPerStopUpload ? null : (
              <div className="col-auto col-lg-2">
                <button
                  type="button"
                  className="btn btn-outline-primary"
                  disabled={this.state.settledDocUploadInProgress}
                  onClick={this.handleSettledDocumentUpload}
                >
                  Upload Document
                </button>
              </div>
            )}

            <div className="col-auto col-lg-2">
              <button
                type="button"
                className="btn btn-outline-info whiteBackgroundBtn"
                onClick={this.modalOpenDocs}
              >
                Documents &nbsp;
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-file-earmark" viewBox="0 0 16 16">
                  <path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5z" />
                </svg>
              </button>
              <SCC.DocumentsModal
                show={this.state.docsModalShow}
                isUploadDocsPerStop={this.props.showFields.includes("UploadDocsPerStop")}
                onHide={this.onHideDocs}
                onHideDocs={this.onHideDocs}
                id={this.props.shipment.id}
                documents={this.props.shipment.documents}
                updateWasSubmitted={this.state.updateWasSubmitted}
                shipment={this.props.shipment}
              />
            </div>

            {isPerStopUpload || !this.state.settledDocUploadStatus ? null : (
              <div className="col-12 mt-2">
                <div className={this.state.settledDocUploadStatusType} role="alert">
                  {this.state.settledDocUploadStatus}
                </div>
              </div>
            )}
          </div>
        </div>
      );
    }
  }

  condRenderDetailBodyAndForm() {
    if (this.state.expandCardDetailsForm) {
      return (
        <div className="card-body">
          {this.condRenderCardBodyDetail()}
          {/* EDITING FIELDS */}
          {/* Accept / Decline Tender buttons */}
          {this.condRenderAcceptDeclineTender()}
          {/* Accept / Decline Load Changes */}
          {this.condRenderAcceptDeclineLoadChanges()}
          {/* All Update Fields */}
          {this.condRenderAllUpdateFields()}
        </div>
      );
    } else {
      return (
        <span className="condRenderDetailBodyAndFormText">
          Click the shipment to see more details / update information.
        </span>
      );
    }
  }

  async populateShipmentV4() {
    // Currently the Carrier Portal uses the shipment service V4, however it calls for shipments with the translate=V2 url param and that changes the shape of the shipment object into a form that looks like the old shipment service V2.   We want to move to V4 but many components expet the shape of the shipment v2 object.   populateShipmentV4() will populate the shipmentV4 state with the V4 shipment object and then we can use the V4 object as needed.  Currenlty this is only called when a user opens the details of a given shipment.
    if (!this.state.shipmentV4) {
      let shipmentV4 = await getShipmentV4(this.props.shipment.id)
      if (shipmentV4) {
        this.setState({ shipmentV4: shipmentV4 })
      }
    }
  }

  // Triggers condRenderDetailBodyAndForm() to show the order details, and render other component such as all the form fields
  // Also populates shipmentV4 state
  showDetailsForms(event) {
    let element = event.target
    if (element.classList.contains('noExpand')) {
      return true;
    } else {
      if (this.state.messagesIcon === "unreadMessages") {
        // this.modalOpenMessaging(event);
      }
      this.setState((prevState) => ({
        expandCardDetailsForm: !prevState.expandCardDetailsForm,
      }));
    }
    this.populateShipmentV4()

  }

  render() {
    // Shipment Card Start
    return (
      // Shipment Card Headder
      <div className="ShipmentCard mt-3">
        <fieldset disabled={this.state.disabledForm}>
          <div
            key={`a2${this.state.checkBoxIDHash}${this.props.shipment.id}`}
            className="cardDiv"
          >
            <div className="card">
              <div className="card-header pointer" onClick={this.showDetailsForms}>
                <div className="row cardHeadderRow sc-header-row">
                  <div className={`col-12 col-md-1 ${this.state.showHideCheckBoxForTableEditMode}`}>
                    {" "}
                    <div className="custom-control form-control-lg custom-checkbox d-flex justify-content-center">
                      <input
                        className="form-check-input custom-control-input position-static form-control-lg"
                        type="checkbox"
                        id={`a${this.state.checkBoxIDHash}${this.props.shipment.id}`}
                        value={this.props.shipment.id}
                        checked={this.state.tableSelect}
                        name={this.props.shipment.id}
                        onChange={this.tableEditCheckEvent}
                      // onChange={this.props.handleChangeTableItem}
                      />
                      <label
                        className="custom-control-label"
                        htmlFor={`a${this.state.checkBoxIDHash}${this.props.shipment.id}`}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-3">

                    <SCC.ReferenceNums
                      render="show"
                      shipment={this.props.shipment}
                    />
                    <SCC.SettlementID
                      render={this.showHilightOrHide("settlementIDHilightHide")}
                      shipment={this.props.shipment}
                    />
                    <SCC.SettlementDate
                      render={this.showHilightOrHide("settlementDateHilightHide")}
                      shipment={this.props.shipment}
                    />
                    <SCC.InvoiceNumber
                      render="show"
                      shipment={this.props.shipment}
                    />
                    <SCC.CarrierQuoteId
                      render={this.showHilightOrHide("carrierQuoteIdHilightHide")}
                      shipment={this.props.shipment}
                    />
                    {this.props.shipment.stops && this.props.shipment.stops.length > 2 && (
                      <span className="d-block d-md-none sc-mobile-label mt-1">
                        <i className="fas fa-map-marker-alt" /> Multiple Stops
                      </span>
                    )}
                  </div>
                  <div className="col-12 col-md-2 sc-header-section">
                    <span className="d-block d-md-none sc-mobile-label">Pickup:</span>
                    <SCC.ShipperConsSummary
                      render={"show"}
                      shipment={this.props.shipment}
                      mode={"ship"}

                    />
                    <br />
                    <br />
                    {/* Pickup Date Read Only Fields */}
                    <SCC.PickupDelDatesTimesStatic01
                      mode={"pickup"}
                      shipment={this.props.shipment}
                      customFields={this.props.shipment.customFields}
                      language={this.state.language}
                    />
                  </div>
                  {/* Account for multistop — hidden on mobile */}
                  <div className="col-2 d-none d-md-block textAlignCenter">
                    <SCC.Arrow
                      shipment={this.props.shipment}
                    />
                  </div>
                  <div className="col-12 col-md-3 sc-header-section">
                    <span className="d-block d-md-none sc-mobile-label">Delivery:</span>
                    <span className="shipCardMiddle3">
                      <SCC.ShipperConsSummary
                        render={"show"}
                        shipment={this.props.shipment}
                        mode={"cons"}

                      />
                      <br />
                      <br />
                      {/* Delivery Date Read Only Fields */}
                      <SCC.PickupDelDatesTimesStatic01
                        mode={"delivery"}
                        shipment={this.props.shipment}
                        customFields={this.props.shipment.customFields}
                        language={this.state.language}
                      />{" "}
                      <SCC.GuaranteedDeliveryIcon
                        render={this.showHilightOrHide("guaranteedDeliveryIconHilightHide")}
                        shipment={this.props.shipment}

                      />
                      <SCC.KissnerCustomDelDate
                        shipment={this.props.shipment}
                      />
                    </span>
                  </div>
                  <div className="col-12 col-md-2 textAlignRight sc-header-section">
                    <SCC.CurrentStatus
                      render="show"
                      shipment={this.props.shipment}
                    />
                    <SCC.AccessorialIcons
                      data={this.props.shipment.loadDetails.accessorials}
                      render={this.showHilightOrHide("accessorialIconsHilightHide")}
                      shipment={this.props.shipment}
                    />
                    <SCC.PaperClipIconAttachments
                      render="noAttachments"
                      onClick={this.modalOpenDocs}
                      numDocuments={this.props.shipment.documents.length}
                    />
                    <MailIcon
                      showHide={this.showHilightOrHide("messages")}
                      render={this.state.messagesIcon}
                      size="fa-2x"
                      onClick={this.modalOpenMessaging}
                      numMessages={this.state.numMessages}
                      numUnreadMessages={this.state.numUnreadMessages}
                    />
                  </div>
                </div>
              </div>
              <SCC.MessagesModal
                show={this.state.messagesModalShow}
                onHide={this.onHideMessages}
                idmessages={this.props.shipment.id}
                log={this.props.shipment.log}
                markMessagesReadLocally={this.markMessagesReadLocally}
              />

              {/* End Shipment Card Headder */}

              <ShipmentDebugView shipment={this.props.shipment} />

              {this.condRenderDetailBodyAndForm()}
            </div>
            <br />
          </div>
        </fieldset>
      </div>
    );
  }
}

ShipmentCard.defaultProps = {
  data: [],
};

export default ShipmentCard;
